import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Input, Row, Col } from 'antd';

import { CommonFormProps, OnboardingLayout } from '.';

import { Form } from '~/components';
import { beginEmailOtp } from '~/api/onboarding';
import { useOnboardingPage, useOnboardingState } from '~/hooks/onboarding';
import onError from '~/errorsHandler';

const { Title, Text } = Typography;

const CreateAccount: FC<CommonFormProps> = (props) => {
  const { name } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const onboardingPage = useOnboardingPage(name);

  const [pageState, setPageState] = useOnboardingState(name);
  const [personalInfoState] = useOnboardingState('personalInfo');
  const [companyContactsState] = useOnboardingState('companyInformation/contacts');

  const onFinish = async (values: any) => {
    const { email } = values;
    const { firstName, lastName } = personalInfoState.formData || {};
    if (email) {
      try {
        // email otp
        setLoading(true);
        const { data } = await beginEmailOtp(email, `${firstName} ${lastName}`);
        const { challengeToken } = data;

        setPageState((prev) => ({
          ...prev,
          formData: {
            email,
            challengeToken,
          },
        }));
        onboardingPage.activateNext();
        onboardingPage.goNext();
      } catch (error: any) {
        onError(error);
      }
      setLoading(false);
    }
  };

  return (
    <OnboardingLayout>
      <Title level={2}>{t('lastStep')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('leaveYourEmail')}</Text>
        <Form
          form={form}
          name={name}
          initialValues={pageState.formData || { email: companyContactsState.formData?.EMAIL }}
          layout="vertical"
          size="large"
          onFinish={onFinish}
        >
          <Form.Item name="email" rules={[{ required: true, type: 'email' }]}>
            <Input placeholder={dt('email')} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {t('createAccount')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default CreateAccount;
